import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button } from "components";

import { theadcontracts, theadcontracttemplates, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";
import { text } from "@fortawesome/fontawesome-svg-core";
import { Button as AntButton, Dropdown, Space } from 'antd';
import { WindowsOutlined, EditOutlined, UserOutlined, UserAddOutlined, LinkOutlined, LoadingOutlined, DeleteOutlined, MoreOutlined, PlusOutlined, SmileTwoTone, PlaySquareOutlined } from '@ant-design/icons';
import ClientModal from "./ClientModal";
var dashboardOrdersTitleStyle =
{
  margin: "0 0 20px 20px",
  color: "#FFF"
};

const ESTADO_FACTURA = "estado-factura";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";
const CONTRATO_ESPERANDO = 229;
const CONTRATO_FICHA_LISTA = 231;
const CONTRATO_FIRMADO = 230;
const CONTRATO_RELLENANDO = 238;

const contractCategories = [
  {
    label: 'Actualización de datos',
    separator: true
  },
  {
    label: 'Actualización',
    value: 457
  },
  {
    label: 'Cambio de titular',
    value: 472
  },
  {
    label: 'Cambio de IBAN',
    value: 469
  },
  {
    label: 'Cambio de domicilio',
    value: 470
  },
  {
    label: 'Nuevo cliente',
    separator: true
  },
  {
    label: 'Nueva fibra',
    value: 447
  },
  {
    label: 'Nuevo WiFi',
    value: 458
  },
  {
    label: 'Nuevo móvil',
    value: 448
  },
  {
    label: 'Nuevo pack fibra',
    value: 449
  },
  {
    label: 'Nuevo pack WiFi',
    value: 459
  },
  {
    label: 'Ampliación de servicios',
    separator: true
  },
  {
    label: 'Añadir móvil',
    value: 451
  },
  {
    label: 'Añadir TV',
    value: 473
  },
  {
    label: 'Cambio a fibra',
    value: 461
  },
  {
    label: 'Conversión a pack fibra',
    value: 450
  },
  {
    label: 'Conversión a pack WiFi',
    value: 460
  },
  {
    label: 'Otros',
    separator: true
  },
  {
    label: 'Cambio de tarifa',
    value: 462
  },
  {
    label: 'Renovar contrato',
    value: 452
  },
  {
    label: 'Servicio extra',
    value: 454
  },
  {
    label: 'Baja',
    value: 453
  },
  {
    label: 'Compromiso de pago',
    value: 468
  }
];

class ContractsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      showPopUp: false,
      popUpConfirmation: null,
      popUpToShow: null,
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      goToCreateCustomer: false,
      loadingContractToCreateCustomer: false,
      isGettingURL: [],
      URLs: [],
      isDeletingContract: [],
      contractToAssociate: null,
      openAssociateModal: false
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.getViewArticlesButton = this.getViewArticlesButton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchContracts = this.searchContracts.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.createBillStatusPopUp = this.createBillStatusPopUp.bind(this);
    this.editBillStatusConfirmation = this.editBillStatusConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.paymentStatus = this.paymentStatus.bind(this);
    this.openBillStatusPopUpFromBill = this.openBillStatusPopUpFromBill.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.deleteContract = this.deleteContract.bind(this);
    this.buildContractsCount = this.buildContractsCount.bind(this);
    this.searchFromCounter = this.searchFromCounter.bind(this);
    this.cleanStatusesFromSearchQuery = this.cleanStatusesFromSearchQuery.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.getURL = this.getURL.bind(this);
    this.deleteContract = this.deleteContract.bind(this);
    this.handleOpenClientModal = this.handleOpenClientModal.bind(this);
    this.handleToggleClientModal = this.handleToggleClientModal.bind(this);

    this.props.cleanContract();
  }
  componentDidMount() {
    this.props.getContractsCount();
    this.props.searchContracts();
    this.props.loadContractTemplates();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.loadingContractToCreateCustomer && this.props.mainState.contract) {
      this.props.createCustomerFromContract(this.props.mainState.contract);
      this.setState({
        goToCreateCustomer: true
      });
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      case ENVIO:
        return this.createDeliveryPopUp();
      case NOTA:
        return this.createNotePopUp();
      case INTERNET:
        return this.configureInternetPopUp();
      case AGREGAR_MOVIL:
        return this.addMobilePopUp();
      case GASTO_EXTRA:
        return this.createExtraExpensePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createCustomer(contract) {
    this.setState({
      loadingContractToCreateCustomer: true
    });
    this.props.getContract(contract.id);
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      case ENVIO:
        this.newDeliverySIMConfirmation();
        break;
      case INTERNET:
        this.configureInternetConfirmation();
        break;
      case AGREGAR_MOVIL:
        this.addMobile();
        break;
      case GASTO_EXTRA:
        this.newExtraExpenseConfirmation();
        break;
      default: ;
    }
  }
  editBillStatusConfirmation() {
    this.props.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBillNumber
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  openBillStatusPopUpFromBill(order) {
    // console.log("################## OPEN BILL STATUS ################");
    // console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      popUpConfirmation: null
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    /* if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{ */
    partialOrders = this.props.mainState.orders.slice(0).reverse();
    /* } */
    partialOrders.map((currentOrder, key) => {
      ordersChartDates.push(
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        })
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");

        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function (value, index, values) {
                  // Convert the number to a string and splite the string every 3 charaters from the end
                  value = value.toString();
                  value = value.split(/(?=(?:...)*$)/);

                  // Convert the array to a string and format the output
                  value = value.join('.');
                  return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    let firstOrderDate =
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[0].fecha))
        .replace(".", "");
    let lastOrderDate =
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[partialOrders.length - 1].fecha))
        .replace(".", "");

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart,
      ordersHistoryTitle: "Histórico de facturas (" + firstOrderDate + " - " + lastOrderDate + ")"
    });
  }
  downloadBill(url, orderNumber, event) {
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(order) {
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if (payment.includes("Pagada")) {
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if (payment.includes("Procesando")) {
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/ {
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    statusReady =
      <Button
        color={statusButtonColor}
        size="sm"
        onClick={() => { this.openBillStatusPopUpFromBill(order) }}
      >
        <i className={statusButtonIcon} /> {payment}
      </Button>;

    return statusReady;
  }
  downloadButton(order) {
    let button =
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if (this.state[order]) {
      button =
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  viewOrderArticles(order) {
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getViewArticlesButton(order) {
    let button =
      <Button
        color="default"
        size="sm"
      /* onClick={e =>
        this.viewOrderArticles(order.numero_pedido, e)
      } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if (true /*order in this.props.mainState.ordersArticles*/) {
      button =
        <Link to={"/facturas/".concat(order)}>
          <Button
            color="info"
            size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
          >
            <div>
              <i className="now-ui-icons education_glasses" /> Ver
            </div>
          </Button>
        </Link>;
    }

    return button;
  }
  searchContracts() {
    if (!this.props.mainState.isSearchingContracts)
      this.props.searchContracts(this.state.searchQuery);
  }
  // deleteContract(contract) {
  //   let contractToDelete = {
  //     contract_id: contract.id
  //   };
  //   this.props.deleteContract(contract);
  // }
  buildTemplateActions(template) {
    let templateActions = [];
    templateActions.push(
      <Link
        key={"openTemplateButton" + template.id}
        to={"/contratos/editar/".concat(template.id)}>
        <Button
          round
          color="info"
          size="sm"
        // icon
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons arrows-1_share-66" /> Abrir
          </div>
        </Button>
      </Link>
    );
    // console.log("TEST OWNER");
    // console.log("template.owner");
    // console.log(template.owner);
    // console.log("this.props.mainState.user.id");
    // console.log(this.props.mainState.user.uid);
    // if (parseInt(template.owner) === parseInt(this.props.mainState.user.uid)) {
    templateActions.push(<span key="separador-1">{" "}</span>);
    templateActions.push(
      <Button
        key={"deleteTemplateButton" + template.id}
        round
        color="danger"
        size="sm"
        // icon
        onClick={e =>
          this.deleteContract(template.id)
        }
        disabled={this.state.isDeletingContract[template.id]}
      >
        <div>
          <i className={this.state.isDeletingContract[template.id] ? "now-ui-icons arrows-1_refresh-69 spin" : "now-ui-icons ui-1_simple-remove"} /> {this.state.isDeletingContract[template.id] ? "Borrando" : "Borrar"}
        </div>
      </Button>
    );

    // }
    return templateActions;
  }
  buildContractActionsBack(contract) {
    let contractActions = [];
    contractActions.push(
      <Link
        key={"viewContractButton" + contract.id}
        to={"/contratos/".concat(contract.id)}>
        <Button
          round
          color="info"
          size="sm"
          icon
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> {/*Ver*/}
          </div>
        </Button>
      </Link>
    );
    contractActions.push(<span key="separador-3">{" "}</span>);
    // Si todavía no está firmado el contrato
    // console.log("---------------- contrato estado firma -----------------");
    // console.log(contract);
    if (contract.estado_id && parseInt(contract.estado_id.tid) !== 230 && parseInt(contract.estado_id.tid) !== 231) {
      contractActions.push(
        <Link
          key={"editContractButton" + contract.id}
          to={"/contratos/editar/".concat(contract.id)}>
          <Button
            round
            color="primary"
            size="sm"
            icon
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
          >
            <div>
              <i className="now-ui-icons loader_gear" /> {/*Editar*/}
            </div>
          </Button>
        </Link>
      );
      contractActions.push(<span key="separador-3">{" "}</span>);
    }
    if (contract.estado_id) {
      if (contract.client_id && parseInt(contract.client_id) > 0 && parseInt(contract.estado_id.tid) === 231) {
        contractActions.push(
          <Link
            key={"viewClientButton" + contract.id + contract.client_id}
            to={"/clientes/fichas/".concat(contract.client_id)}>
            <Button
              round
              color="primary"
              size="sm"
              icon
            /* onClick={e =>
              this.viewOrderArticles(order.numero_pedido, e)
            } */
            >
              <div>
                <i className="now-ui-icons arrows-1_share-66" /> {/*Ver ficha*/}
              </div>
            </Button>
          </Link>
        );
        contractActions.push(<span key="separador-3">{" "}</span>);
      } else if (parseInt(contract.estado_id.tid) === 230) {
        contractActions.push(<span key="separador-2">{" "}</span>);
        contractActions.push(
          // <Link to={"/clientes/nuevo"}>
          <Button
            key={"createClientButton" + contract.id}
            round
            color="primary"
            size="sm"
            icon
            onClick={e =>
              this.createCustomer(contract)
            }
          >
            <div>
              <i className="now-ui-icons ui-1_simple-add" /> {/*Crear ficha*/}
            </div>
          </Button>
          // </Link>
        );
        contractActions.push(<span key="separador-3">{" "}</span>);
      }
    }
    contractActions.push(
      <Button
        round
        color="warning"
        size="sm"
        disabled={((this.state.isGettingURL && this.state.isGettingURL[contract.id]) || this.state.URLs[contract.id])}
        icon
        onClick={e =>
          this.getURL(contract.id, contract.pin)
        }
      >
        <div>
          <i className={(this.state.isGettingURL && this.state.isGettingURL[contract.id]) ? "now-ui-icons arrows-1_refresh-69 spin" : "now-ui-icons business_globe"} /> {/*Enlace*/}
        </div>
      </Button>
    );
    contractActions.push(<span key="separador-3">{" "}</span>);
    contractActions.push(
      <Button
        round
        color="danger"
        size="sm"
        disabled={((this.state.isDeletingContract && this.state.isDeletingContract[contract.id]))}
        icon
        onClick={e =>
          this.deleteContract(contract.id)
        }
      >
        <div>
          <i className={(this.state.isDeletingContract && this.state.isDeletingContract[contract.id]) ? "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "now-ui-icons ui-1_simple-remove"} /> {/*Enlace*/}
        </div>
      </Button>
    );
    contractActions.push(<span key="separador-3">{" "}</span>);
    return contractActions;
  }
  handleOpenClientModal(contract) {
    // console.log(contract)
    this.setState({ contractToAssociate: contract }),
      this.setState({ openAssociateModal: true })
  }
  handleToggleClientModal(boolean) {
    this.setState({ openAssociateModal: boolean })
  }
  buildContractActions(contract) {
    let customer_id = null;
    if (contract.client_id && parseInt(contract.client_id) > 0) {
      customer_id = contract.client_id;
    }
    if (!customer_id) {
      if (contract.existing_customer && parseInt(contract.existing_customer) > 0) {
        customer_id = contract.existing_customer;
      }
    }
    const items = [
      {
        label: 'Ver',
        key: 'ver-contrato',
        icon: <PlaySquareOutlined />,
        onClick: () => this.redirectTo("/contratos/".concat(contract.id))
      },
      {
        label: 'Editar',
        key: 'editar-contrato',
        icon: <EditOutlined />,
        onClick: () => this.redirectTo("/contratos/editar/".concat(contract.id)),
        disabled: !(contract.estado_id && parseInt(contract.estado_id.tid) !== 230 && parseInt(contract.estado_id.tid) !== 231)
      },
      {
        label: 'Ficha cliente',
        key: 'ficha-cliente',
        icon: <UserOutlined />,
        onClick: () => this.redirectTo("/clientes/fichas/".concat(customer_id)),
        disabled: !customer_id
      },
      {
        label: 'Crear cliente',
        key: 'crear-cliente',
        icon: <PlusOutlined />,
        onClick: () => this.createCustomer(contract),
        disabled: customer_id || parseInt(contract.estado_id.tid) !== 230
      },
      {
        label: 'Asociar cliente',
        key: 'asociar-cliente',
        icon: <PlusOutlined />,
        onClick: () => this.handleOpenClientModal(contract),
        // disabled: customer_id || parseInt(contract.estado_id.tid) !== 230
      },
      {
        label:
          this.state.isGettingURL && this.state.isGettingURL[contract.id] ? (
            "Generando"
          ) : (
            "Generar enlace"
          ),
        key: 'generar-enlace',
        icon:
          this.state.isGettingURL && this.state.isGettingURL[contract.id] ? (
            <LoadingOutlined />
          ) : (
            <LinkOutlined />
          ),
        disabled:
          (this.state.isGettingURL && this.state.isGettingURL[contract.id]) ||
          this.state.URLs[contract.id],
        onClick: () => this.getURL(contract.id, contract.pin)
      },
      {
        danger: true,
        label:
          this.state.isDeletingContract && this.state.isDeletingContract[contract.id] ? (
            "Eliminando"
          ) : (
            "Eliminar"
          ),
        key: 'eliminar-contrato',
        icon:
          this.state.isDeletingContract && this.state.isDeletingContract[contract.id] ? (
            <LoadingOutlined />
          ) : (
            <DeleteOutlined />
          ),
        disabled:
          (this.state.isDeletingContract && this.state.isDeletingContract[contract.id]) || !(/*contract.estado_id && parseInt(contract.estado_id.tid) !== 230 &&*/ parseInt(contract.estado_id.tid) !== 231),
        onClick: () => this.deleteContract(contract.id)
      }
    ];
    // console.log("acciones contrato", contractActions);
    const menuProps = {
      items,
      // onClick: () => console.log("menu click")
    };
    return (
      <Dropdown menu={menuProps}>
        <AntButton loading={(this.state.isDeletingContract && this.state.isDeletingContract[contract.id]) || (this.state.isGettingURL && this.state.isGettingURL[contract.id])}>
          <Space>
            Acciones
            <div className="acciones-contrato"><MoreOutlined /></div>
          </Space>
        </AntButton>
      </Dropdown>
    );
  }
  getURL(contract_id, contract_pin) {
    let isGettingURL = this.state.isGettingURL;
    isGettingURL[contract_id] = true;
    this.setState({ isGettingURL: isGettingURL });

    this.props.getContractURL(contract_id, contract_pin).then(result => {
      /* ////// console.log("################## RESPUESTA ################");
      ////// console.log(result); */
      let isGettingURL = this.state.isGettingURL;
      isGettingURL[contract_id] = false;
      let response = result; // result.data;
      let URLs = this.state.URLs;
      if (response.result === "OK") {
        URLs[contract_id] = response.url;
      } else {
        // this.showError(response.error);
      }
      this.setState({
        isGettingURL: isGettingURL,
        URLs: URLs
      });
    })
      .catch((error) => {
        // Error 😨
        this.setState({
          isGettingPaymentLink: false
        });
        // this.showError("Error al obtener el enlace, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  deleteContract(contract_id) {
    let isDeletingContract = this.state.isDeletingContract;
    if (!isDeletingContract) isDeletingContract = [];
    if (isDeletingContract[contract_id]) return;
    isDeletingContract[contract_id] = true;
    this.setState({ isDeletingContract: isDeletingContract });

    this.props.deleteContractAsync(contract_id).then(result => {
      /* ////// console.log("################## RESPUESTA ################");
      ////// console.log(result); */
      let isDeletingContract = this.state.isDeletingContract;
      isDeletingContract[contract_id] = false;
      let response = result; // result.data;
      this.setState({
        isDeletingContract: isDeletingContract
      });
      if (response.ok) {
        this.props.getContractsCount();
        this.props.searchContracts();
        this.props.loadContractTemplates();
      } else {
        // this.showError(response.error);
      }
    })
      .catch((error) => {
        // Error 😨
        let isDeletingContract = this.state.isDeletingContract;
        isDeletingContract[contract_id] = false;
        this.setState({
          isDeletingContract: isDeletingContract
        });
        // this.showError("Error al eliminar el contrato. (" + error + ")");
      });
  }
  buildContractState(contract) {
    let contractState = null;
    let stateText = "Error";
    let stateColor = "default";
    let stateIcon = "ui-1_simple-remove";
    let signedDate = "";
    let signedSince = "";
    const regex = /(<([^>]+)>)/gi;
    if (contract.estado_id && parseInt(contract.estado_id.tid) > 0) {
      let state_id = parseInt(contract.estado_id.tid);
      switch (state_id) {
        case CONTRATO_ESPERANDO:
          stateText = contract.estado;
          stateColor = "danger";
          stateIcon = "ui-2_time-alarm";
          break;
        case CONTRATO_FICHA_LISTA:
          stateText = contract.estado;
          stateColor = "primary";
          stateIcon = "ui-2_favourite-28";
          signedDate = contract.signed_date.replace(regex, " ");
          signedSince = contract.signed_since.replace(regex, " ");
          break;
        case CONTRATO_FIRMADO:
          stateText = contract.estado;
          stateColor = "info";
          stateIcon = "ui-1_check";
          signedDate = contract.signed_date.replace(regex, " ");
          signedSince = contract.signed_since.replace(regex, " ");
          break;
        case CONTRATO_RELLENANDO:
          stateText = contract.estado;
          stateColor = "warning";
          stateIcon = "arrows-1_refresh-69 spin reposition-spin";
          break;
        default:
          stateText = "Error";
          stateColor = "default";
          stateIcon = "ui-1_simple-remove";
          break;
      }
    } else {
      stateText = "Error";
      stateColor = "default";
      stateIcon = "ui-1_simple-remove";
    }

    contractState = (
      <div style={{ position: "relative" }}>
        <Button
          round
          color={stateColor}
          size="sm"
        // icon
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
        >
          <div>
            <i className={"now-ui-icons " + stateIcon} /> {stateText}
          </div>
        </Button>
        <div className="contract-signed-date signed-date-visible"><span>{signedDate}</span></div>
        <div className="contract-signed-since signed-since-visible"><span>{signedSince}</span></div>
      </div>
    );
    return contractState;
  }
  getContractTemplates() {
    let contentToDisplay = null;
    let contractsToDisplay = null;
    // console.log("#################### TEMPLATES LIST #####################");
    // console.log(this.props.mainState.contractTemplates);
    if (this.props.mainState.contractTemplatesLoaded && this.props.mainState.contractTemplates.length > 0) {
      contractsToDisplay = this.props.mainState.contractTemplates.slice(0);
      contentToDisplay =
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Plantillas</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {theadcontracttemplates.map((prop, key) => {
                    if (key === theadcontracttemplates.length - 1)
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    return <th key={key} className="text-center">{prop}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {contractsToDisplay.map((template, key) => {
                  return (
                    <tr key={template.id}>
                      <td className="text-center">{template.titulo}</td>
                      <td className="text-center">{this.buildTemplateActions(template)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>;
    } else if (this.props.mainState.contractTemplatesLoaded && this.props.mainState.contractTemplates.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
      contentToDisplay = (
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Contratos</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay plantillas...
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    } else {
      contentToDisplay =
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Plantillas</CardTitle>
          </CardHeader>
          <CardBody>
            <span><i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />  Cargando plantillas...</span>
          </CardBody>
        </Card>;
    }
    return contentToDisplay;
  }
  getContractStatusColor(status) {
    let color = "default";

    status = parseInt(status);
    switch (status) {
      case 229:
        color = "danger";
        break;
      case 238:
        color = "warning";
        break;
      case 230:
        color = "info";
        break;
      default:
        break;
    }

    return color;
  }
  buildContractsCount() {
    let contractsCount = null;
    if (this.props.mainState.contractsCount && this.props.mainState.contractsCount.length > 0) {
      contractsCount =
        <Row>
          {this.props.mainState.contractsCount.map(currentStatus => {
            let color = this.getContractStatusColor(currentStatus.status_id);
            let textColor = "text-white";
            if (color === "warning") textColor = "txt-black";
            return (
              <Col
                xs={12}
                md={12}
                key={currentStatus.status_id} >
                <Card
                  className={textColor}
                  color={color}
                  onClick={() => this.searchFromCounter(currentStatus.status_name)}>
                  <CardHeader className="text-center">
                    <CardTitle tag="h4" style={{ marginTop: "0px" }}>
                      <span
                        style={{
                          borderRadius: "4px",
                          background: "rgba(0,0,0,0.2)",
                          position: "absolute",
                          left: "0",
                          top: "0",
                          height: "100%",
                          width: "4em",
                          lineHeight: "2.5em",
                          fontWeight: "bold",
                          whiteSpace: "nowrap"
                        }}
                      >{currentStatus.count}</span> {currentStatus.status_name}
                    </CardTitle>
                  </CardHeader>
                </Card>
              </Col>
            );
          })}
        </Row>;
    } else {
      contractsCount =
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Estado contratos</CardTitle>
          </CardHeader>
          <CardBody>
            No hay contratos pendientes
          </CardBody>
        </Card>;
    }
    return contractsCount;
  }
  searchFromCounter(status) {
    let newSearchQuery = "";
    let currentQuery = this.state.searchQuery;
    currentQuery = this.cleanStatusesFromSearchQuery(status, currentQuery);

    if (currentQuery && currentQuery.length > 0) {
      if (!currentQuery.includes(status)) {
        newSearchQuery = status + " + " + currentQuery;
      } else {
        newSearchQuery = currentQuery;
      }
    } else {
      newSearchQuery = status;
    }
    this.setState({ searchQuery: newSearchQuery });
    this.props.searchContracts(newSearchQuery);
  }
  cleanStatusesFromSearchQuery(status, query) {
    this.props.mainState.contractsCount.map(currentStatus => {
      query = query.replace(currentStatus.status_name, status);
      let expression = new RegExp(currentStatus.status_name, "gi");
      query = query.replace(expression, "");
    });
    return query;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    if (this.state.goToCreateCustomer === true) {
      this.redirectTo("/clientes/crear");
      // return <Redirect to="/clientes/crear" />;
    }
    //console.log()
    // if (this.props.mainState.contractsLoaded && this.props.mainState.contracts.length > 0) this.loadOrdersChart();
    let contentToDisplay = null;
    let contractsToDisplay = null;
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);
    if (this.props.mainState.contractsLoaded && this.props.mainState.contracts.length > 0) {
      contractsToDisplay = this.props.mainState.contracts.slice(0);
      contentToDisplay =
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Contratos</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {theadcontracts.map((prop, key) => {
                    if (key === theadcontracts.length - 1)
                      return (
                        <th key={key} className={prop === "Título" ? "text-left" : "text-center"}>
                          {prop}
                        </th>
                      );
                    return <th key={key} className={prop === "Título" ? "text-left" : "text-center"}>{prop}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {contractsToDisplay.map((contract, key) => {

                  let currentCustomer = null;
                  let currentCustomerLink = null;
                  let customer_id = null;
                  if (contract.client_id && parseInt(contract.client_id) > 0) {
                    customer_id = contract.client_id;
                  }
                  if (!customer_id) {
                    if (contract.existing_customer && parseInt(contract.existing_customer) > 0) {
                      customer_id = contract.existing_customer;
                    }
                  }
                  if (contract.cliente_id in this.props.mainState.customers) {
                    //TODO: Link to existing client
                    // currentCustomer = this.props.mainState.customers[contract.cliente_id][0];
                    // currentCustomerLink = 
                    //   <Link to={"/clientes/fichas/".concat(currentCustomer.id)}>
                    //   {currentCustomer.nombre_completo} {currentCustomer.primer_apellido} {currentCustomer.segundo_apellido}
                    // </Link>;
                  } else {
                    //if (!isSearchingCustomer) this.props.searchCustomer();
                    //isSearchingCustomer = true;
                    // currentCustomerLink =                       
                    //   <div className="btns-mr-5">
                    //     <Button icon color="default" size="sm">
                    //       <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
                    //     </Button>
                    //   </div>;
                  }
                  let contractCategory = null;
                  // console.log(contract)
                  if (contract.taxonomy_term_data_field_data_field_categoria_contrato_tid && contract.taxonomy_term_data_field_data_field_categoria_contrato_tid !== "") {
                    for (let i = 0; i < contractCategories.length; i++) {
                      const category = contractCategories[i];
                      if (parseInt(category.value) === parseInt(contract.taxonomy_term_data_field_data_field_categoria_contrato_tid)) contractCategory = category;
                    }
                    if (contractCategory) {
                      contractCategory = (
                        <AntButton block type="primary" onClick={() => this.redirectTo("/contratos/".concat(contract.id))}>
                          {contractCategory.label}
                        </AntButton>
                      );
                    } else {
                      contractCategory = (
                        <AntButton block danger={true} type="primary" onClick={() => this.redirectTo("/contratos/".concat(contract.id))}>
                          Sin categoría
                        </AntButton>
                      );
                    }
                  } else {
                    contractCategory = (
                      <AntButton block danger={true} type="primary" onClick={() => this.redirectTo("/contratos/".concat(contract.id))}>
                        Sin categoría
                      </AntButton>
                    );
                  }
                  // let overcharge = "";
                  // if (!Array.isArray(contract.fecha_devolucion)) {
                  //   overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
                  // }
                  // if (!Array.isArray(contract.fecha_pago_devolucion)) {
                  //   overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
                  // }
                  let customerExists = <SmileTwoTone twoToneColor={customer_id ? "#52c41a" : "#eb2f96"} />
                  let accessRow = null;
                  if (this.state.URLs && this.state.URLs[contract.id]) {
                    accessRow = <td className="text-center">{this.state.URLs[contract.id]}</td>;
                  } else {
                    accessRow = <td className="text-center">
                      <span className="contract-access"><span className="contract-name">ID </span>{contract.id}</span>
                      <span className="contract-access"><span className="contract-name">PIN </span>{contract.pin}</span>
                    </td>;
                  }
                  return (
                    <tr key={contract.id}>
                      <td className="text-center">{contractCategory}</td>
                      <td className="text-left">
                        <span className="contract-title">{customerExists}{" "}{contract.titulo}</span>
                        <span className="contract-creation">Creado por <span className="contract-author">{contract.autor}</span> el <span className="contract-date">{contract.fecha ? contract.fecha.split("-")[0] : ""}</span></span>
                      </td>
                      {/* <td className="text-center">{contract.fecha? contract.fecha.split("-")[0] : ""}</td> */}
                      {/* <td className="text-center">{contract.autor}</td> */}
                      <td className="text-center">{this.buildContractState(contract)}</td>
                      {accessRow}
                      <td className="text-center">{this.buildContractActions(contract)}</td>
                      {/* <td className="text-center">{contract.numero_pedido}</td>
                      <td className="text-center">{contract.total}{overcharge}</td>
                      <td className="text-center">    
                      {this.paymentStatus(contract)} 
                      </td>
                      <td className="text-center">
                        <Button
                          color="danger"
                          size="sm"
                          onClick={e =>
                            this.downloadBill(contract.enlace_pdf, contract.numero_pedido, e)
                          }
                        >
                          {this.downloadButton(contract.numero_pedido)}
                        </Button>{" "}
                        {this.getViewArticlesButton(contract.numero_pedido)}                        
                      </td> */}
                      {/* order.data.map((prop, key) => {
                        if (key === thead.length - 1)
                          return (
                            <td key={key} className="text-right">
                              {prop}
                            </td>
                          );
                        return <td key={key}>{prop}</td>;
                      }) */}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>;
    } else if (!this.props.mainState.isSearchContractsResult && this.props.mainState.contractsLoaded && this.props.mainState.contracts.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
      contentToDisplay = (
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Contratos</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay contratos ...
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    } else if (
      this.props.mainState.isSearchContractsResult &&
      this.props.mainState.contractsLoaded &&
      this.props.mainState.contracts.length === 0
    ) {
      contentToDisplay = (
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Contratos</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay resultados para{" "}
                <b>{this.props.mainState.searchContractsQuery}</b>...
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    } else {
      contentToDisplay =
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Contratos</CardTitle>
          </CardHeader>
          <CardBody>
            <span>No hay contratos para mostrar que coincidan con la búsqueda</span>
          </CardBody>
        </Card>;
    }

    let createContractButton = (
      <Link to={"/contratos/nuevo"}>
        <Button round color="info">
          <i className="now-ui-icons ui-1_simple-add" /> Nuevo contrato
        </Button>
      </Link>
    );

    let contractTemplates = this.getContractTemplates();
    let contractsCount = this.buildContractsCount();

    return (
      <div>
        <PanelHeader
          size="sm"
        />
        <ClientModal
          contract={this.state.contractToAssociate}
          openModal={this.state.openAssociateModal}
          handleToggleModal={this.handleToggleClientModal}
        />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text"
                    placeholder="Buscar contrato..."
                    value={this.state.searchQuery}
                    onChange={(e) => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if (e.keyCode == 13) {
                        //Enter is key code 13
                        this.searchContracts();
                        // put the login here
                      }
                    }}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingBills
                        ? "default"
                        : "primary"
                    }
                    round
                    icon
                    onClick={this.searchContracts}>
                    <i className={this.props.mainState.isSearchingBills ?
                      "now-ui-icons arrows-1_refresh-69 spin reposition-spin" : "now-ui-icons ui-1_zoom-bold"} />
                  </Button>
                </CardBody>
              </Card>
            </Col>
            {/*<Label sm={2}>Buscar</Label>*/}
            <Col lg={3} md={6} xs={12}>
              {createContractButton}
            </Col>
          </Row>
          <Row>
            {/* {this.state.showDetail && orderArticles} */}
            <Col xs={12} md={8}>
              {contentToDisplay}
            </Col>
            <Col xs={12} md={4}>
              {contractsCount}
              {contractTemplates}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default ContractsList;



// WEBPACK FOOTER //
// ./src/views/Contracts/ContractsList.jsx